import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { LOGIN } from '../../tools/ApiRoutes';
import APP from '../../tools/AppRoutes';
import Context from '../Master/SessionProvider';
import '../../styles/site.css';
import LoadingButton from '@mui/lab/LoadingButton';
import { Helmet } from 'react-helmet-async';
import enviarPeticion from '../../tools/EnviarPeticion';
import Alert from '../../components/Alert';

const Login = ({ history }) => {

    const [access, setAccess] = useState({ login: '', password: '', showPassword: false });
    const { login, logout, menu, marcarMenu } = useContext(Context);
    const [ alert, setAlert ] = useState({ msg: '', severity: 'success', open: false });

    const handleChange = (prop) => (event) => {
        setAccess({ ...access, [prop]: event.target.value });
        checkForm();
    };

    const closeAlert = () => setAlert({ msg: '', severity: 'success', open: false });


    const checkForm = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('Menu');
    }

    const recuperarAcceso = () => {
        window.open('https://appsd.compusoluciones.com/csActualizaInfo/recuperar.aspx', '_blank')
    }

    const handleSubmit = async (event) => {
        event.preventDefault();  

        //VALIDAMOS USUARIO
        if(access.login === ''){
            setAlert({msg: 'Ingresa el usuario y/o la contraseña', severity: "warning", open: true });
            return;
        }

        //VALIDAMOS CONTRASEÑA
        if(access.password === ''){
            setAlert({msg: 'Ingresa el usuario y/o la contraseña', severity: "warning", open: true });
            return;
        }

        //HACEMOS PETICIÓN QUE EVALÚA USUARIO Y CONTRASEÑA
        const data = {
            Usuario: access.login,
            Password: access.password
        }

        const config = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        };

        const res = await enviarPeticion(config, LOGIN.ValidarUsuario);

        if (res.WasSuccessful){
            //GUARDAMOS LA SESIÓN
            login(res.data[0]);

            const pathname = `#${APP.ALTAS}`;
            marcarMenu({...menu, pathname });
            history.push(APP.ALTAS);
        }
        else {
            //SI FALLA MOSTRAMOS MENSAJE 
            setAccess({ ...access, password: '', login: '' });
            setAlert({msg: res.Message, severity: "error", open: true });
            logout();
        }
    }

    useEffect(() => {

        return (() => {
            //console.log("");
        });

    },[]);

    return (
        <>
        <Helmet>
            <title>Alta Clientes Colombia</title>
        </Helmet>
        
        <div className="container">
            <div className="row">
                <div className="col">
                    <p className="areaTitulo tituloLogin">Bienvenido</p>
                </div>
            </div>

            {
                alert.open ? <Alert msg={alert.msg} open={alert.open} severity={alert.severity} closeAlert={closeAlert}/> : <></>
            }
              
            <div className="offset-md-3 col-md-6 col-sm-8 offset-sm-2 col-8 offset-2">
                <form className="formLogin">
                    <div className="form-group">
                        <div className="row">
                            <div className="col">
                                <input type='text' name='txtNombre' value={access.login} onChange={handleChange('login')} placeholder='Usuario' style={{backgroundColor: 'white', height: '39px', width: '100%', padding: '4px 12px'}}></input>
                                {/* <TextFieldCS name="txtNombre" value={access.login} onChange={handleChange('login')} placeholder='Usuario' style={{backgroundColor: 'white', height: '39px', padding: '4px 12px'}}></TextFieldCS> */}
                                {/* <FormControl className='textBoxLogin' style={{ backgroundColor: '#FFFFFF', width: '100%', marginBottom: 15 }} variant='filled'>
                                    <InputLabel htmlFor="component-filled" className='marginTopMenos7'>Usuario</InputLabel>
                                    <FilledInput id="component-filled" autoComplete='off' className='textBoxLogin' value={access.login} onChange={handleChange('login')} />
                                </FormControl> */}
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="row">
                            <div className="col">
                                <input type='password' name='txtPassword' value={access.password} onChange={handleChange('password')} placeholder='Contraseña' style={{backgroundColor: 'white', height: '39px', width: '100%', padding: '4px 12px'}} onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleSubmit(e);
                                    }
                                }}></input>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col" >
                            <LoadingButton className="botonAmarillo floatLeft" onClick={handleSubmit} variant="contained">Ingresar</LoadingButton>
                        </div>
                        <div className="col" style={{textAlign: 'center'}}>
                            <button onClick={recuperarAcceso} style={{border: 'none', padding: '0', backgroundColor: 'inherit', color: 'white'}}><span>¿Olvidaste tu contraseña?</span></button>
                        </div>
                    </div>
                </form>
            </div>
            <div className='fontNewsGothic fontSize14 marginTop75'>
                <center>Navegador recomendado: Google Chrome</center>
            </div>
        </div>
        </>
    )
}

export default React.memo(withRouter(Login));